/* ============================================================
   X-GLOBAL — additive JS: Wishlist, Cookie bar, Back-to-top,
   Footer mobile accordion. Vanilla JS, data-attribute driven.
   Every module no-ops when its markup/setting is absent.
   ============================================================ */
(function () {
  'use strict';

  function lxEscape(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------------- Wishlist (localStorage 'lux_wishlist') ---------------- */
  (function () {
    var KEY = 'lux_wishlist';
    var grid = document.querySelector('[data-wishlist-grid]');
    var hasButtons = document.querySelector('[data-wishlist]');
    if (!grid && !hasButtons) return;

    function get() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; }
      catch (e) { return []; }
    }
    function set(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }

    function syncButtons() {
      var list = get();
      document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
        var handle = btn.getAttribute('data-wishlist');
        var on = list.indexOf(handle) !== -1;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var label = btn.querySelector('[data-wishlist-label]');
        if (label) label.textContent = on ? 'Saved to wishlist' : 'Add to wishlist';
      });
    }

    function money(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
      return 'Rs ' + (cents / 100).toLocaleString('en-PK');
    }

    function cardHTML(p) {
      var img = p.featured_image
        ? '<img class="product-card__img" src="' + lxEscape(p.featured_image) + '" alt="' + lxEscape(p.title) + '" loading="lazy">'
        : '';
      return '<div class="product-card">' +
        '<a class="product-card__media" href="' + lxEscape(p.url) + '" aria-label="' + lxEscape(p.title) + '">' + img + '</a>' +
        '<div class="product-card__info">' +
        '<h3 class="product-card__title"><a href="' + lxEscape(p.url) + '">' + lxEscape(p.title) + '</a></h3>' +
        '<div class="price-wrap"><span class="price">' + lxEscape(money(p.price)) + '</span></div>' +
        '<button type="button" class="wishlist-remove" data-wishlist-remove="' + lxEscape(p.handle) + '">Remove</button>' +
        '</div></div>';
    }

    function renderPage() {
      if (!grid) return;
      var list = get();
      var empty = document.querySelector('[data-wishlist-empty]');
      if (!list.length) {
        grid.innerHTML = '';
        if (empty) empty.hidden = false;
        return;
      }
      if (empty) empty.hidden = true;
      grid.innerHTML = '<p class="wishlist-loading">Loading your wishlist…</p>';
      Promise.all(list.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) {
          return r.ok ? r.json() : null;
        }).catch(function () { return null; });
      })).then(function (items) {
        var valid = items.filter(Boolean);
        grid.innerHTML = valid.map(cardHTML).join('');
        if (!valid.length && empty) empty.hidden = false;
      });
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-wishlist]');
      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        var handle = toggle.getAttribute('data-wishlist');
        var list = get();
        var i = list.indexOf(handle);
        if (i > -1) { list.splice(i, 1); } else { list.push(handle); }
        set(list);
        syncButtons();
        renderPage();
        return;
      }
      var remove = e.target.closest('[data-wishlist-remove]');
      if (remove) {
        var rh = remove.getAttribute('data-wishlist-remove');
        set(get().filter(function (h) { return h !== rh; }));
        syncButtons();
        renderPage();
      }
    });

    syncButtons();
    renderPage();
  })();

  /* ---------------- Cookie consent bar (localStorage 'lux_cookie_consent') ---------------- */
  (function () {
    var bar = document.querySelector('[data-cookie-bar]');
    if (!bar) return;
    var KEY = 'lux_cookie_consent';
    var seen = null;
    try { seen = localStorage.getItem(KEY); } catch (e) {}
    if (seen) return;
    bar.hidden = false;
    function done(value) {
      try { localStorage.setItem(KEY, value); } catch (e) {}
      bar.hidden = true;
    }
    var accept = bar.querySelector('[data-cookie-accept]');
    var decline = bar.querySelector('[data-cookie-decline]');
    if (accept) accept.addEventListener('click', function () { done('accepted'); });
    if (decline) decline.addEventListener('click', function () { done('declined'); });
  })();

  /* ---------------- Back-to-top (appears after 600px) ---------------- */
  (function () {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;
    function onScroll() {
      var show = window.scrollY > 600;
      btn.hidden = !show;
      btn.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();

  /* ---------------- Footer: keep link-list accordions open on desktop ---------------- */
  (function () {
    var accordions = document.querySelectorAll('[data-footer-accordion]');
    if (!accordions.length) return;
    function fit() {
      var desktop = window.matchMedia('(min-width: 750px)').matches;
      accordions.forEach(function (d) { if (desktop) d.open = true; });
    }
    window.addEventListener('resize', fit);
    fit();
  })();
})();
